import { useDispatch, useSelector } from "../../../../hooks";
import { QuizStatus } from "../../../../redux/quizzes";
import { requestQuizQuestion } from "../../../../redux/quizzes/request-quiz-question.handler";
import { Button, IButtonProps } from "../../../../components/Buttons/Button/Button";
import currencyIcon from '../../../../icons/currency.png';
import styles from "./QuizResultBlock.module.scss";
import { formatNumberWithSpaces } from "../../../../utils/numbers";

export const QuizResultBlock = () => {
    const { answerResult, quiz, isExpired } = useSelector(store => store.quiz);
    const dispatch = useDispatch();

    if (!quiz) {
        return <></>;
    }

    const getResultText = () => {
        if (answerResult === null)
            return 'Время вышло'

        return answerResult.isRightAnswer ? 'Правильно!' : 'Не правильно';
    }

    const getRewardText = () => answerResult && answerResult.isRightAnswer ? `Вы заработали` : `Вы могли заработать`;

    const getRewardValue = () => {
        if (answerResult && answerResult.isRightAnswer)
            return answerResult.reward;

        return quiz.status !== QuizStatus.WaitingFinishRequest ? quiz.question.reward : 0;
    }

    const nextQuestion = () => dispatch(requestQuizQuestion());

    const resultClass = () => answerResult && answerResult.isRightAnswer ? styles.correctContainer : styles.incorrectContainer;

    const titleClass = () => answerResult && answerResult.isRightAnswer ? styles.correctTitle : styles.incorrectTitle;

    const getButton = () => {        
        const sets: IButtonProps = quiz.stageNumber < quiz.totalQuestionsCount
            ? { handler: nextQuestion, caption: 'Следующий вопрос', type: 'green' }
            : { handler: nextQuestion, caption: 'Далее', type: 'orange' }

        return (
            <div className={styles.button}>
                <Button {...sets} />
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <div className={`${styles.resultContainer} ${resultClass()}`}>
                <div className={styles.resultBlock}>                
                    <h2 className={`${styles.resultTitle} ${titleClass()}`}>
                        { getResultText() }
                    </h2>

                    { quiz.status !== QuizStatus.Expired &&
                        <>
                            <p className={styles.earnText}>{ getRewardText() }</p>

                            <div className={styles.rewardBlock}>
                                <img src={currencyIcon} alt="currency" />
                                <span className={styles.rewardAmount}>{ formatNumberWithSpaces(getRewardValue()) }</span>
                            </div>
                        </>
                    }

                    { !isExpired &&
                        <>
                            <p className={styles.correctAnswerLabel}>Правильный ответ:</p>
                            { answerResult && <p className={styles.correctAnswer}>{ answerResult.answerText }</p> }
                        </>
                    }
                    
                </div>
            </div>

            { getButton() }
        </div>
    );
};